import './fonts/fonts.css'
import './utils/style.css'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'
import { SnackbarProvider } from 'notistack'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import { Box } from '@mui/system'
import { HelmetProvider } from 'react-helmet-async'
import store from './redux/store'
import theme from './CustomTheme'
import Routes from './routes'
import RTL from './components/Layout/RtlStyling'
import Head from './components/helpers/Head'
import BiometricEnrollmentGate from './components/Biometric/BiometricEnrollmentGate'
// TEMPORARY migration gate for native builds released before the permanent
// native force-update checker existed. Remove once those builds are gone.
import LegacyNativeVersionGate from './components/LegacyNativeVersionGate/LegacyNativeVersionGate'

const App = () => (
  <Provider store={store}>
    <HelmetProvider>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <SnackbarProvider maxSnack={3}>
          <Router>
            <RTL>
              <Head />
              <LegacyNativeVersionGate>
                <Box sx={{ fontFamily: 'var(--app-font-current)' }}>
                  <Routes />
                </Box>
                <BiometricEnrollmentGate />
              </LegacyNativeVersionGate>
            </RTL>
          </Router>
        </SnackbarProvider>
      </ThemeProvider>
    </StyledEngineProvider>
    </HelmetProvider>
  </Provider>
);

export default App;
